import React, { useState, useEffect, useRef, useCallback } from 'react'
import { useHistory, useParams, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux'

import {
    AppLayout, Icon, Box, SpaceBetween, Header, Button,
    Container, Spinner, Alert,  Modal, Link,
    CopyToClipboard,
    ExpandableSection,
    StatusIndicator,
    Input
} from '@amzn/awsui-components-react';
import SideNav from './SideNav';
import WaitForPageAccess from '../../WaitForPageAccess'
import './history.scss'
import { checkIfPortalAdmin, checkIfSupportAdmin } from "../../checkPageAccess";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import { useAuth } from "../../context/AuthContextProvider";
import { Storage } from 'aws-amplify';
import { setCurrentAppId } from '../../store/userAuthSlice';
import { queryFRISCOTransactionsByAppIdProcessIdIndex} from "src/Ateam-BI/Templates/Utils/AppActivityUtils"
import {getProcessById} from "src/Ateam-BI/Templates/Utils/AppActivityUtilsAppsyncPlus"
import { PROCESS_KEYS, workdocsBaseUrl } from './Constants';
import { configureFriscoS3, configureGenericS3 } from 'src/context/AuthContextUtility'
import { isApprover, isUploaderAllowed } from './AccessUtilities';
import { isCorpAdmin } from '../Templates/Utils/Permissions';
import appSettings from '../CorpReporting/app_settings';
import FriscoJobErrors from './FriscoJobErrors';
import { convertEpochToPST } from './FilterUtilities';
import DownloadableFileListComponent from '../Templates/components/DownloadableFileListComponent';
import FriscoTransactionFileListViewer from './FriscoTransactionFileListViewer';
import useVisibleTimeTracker from 'src/katalMetrics/useVisibleTimeTracker';
import { ACTION_METHODS, METRIC_TYPE, SITE_SERVICES } from 'src/katalMetrics/metricsModels';
import { createKatalTimerStopWatch, stopAndCaptureTimeMetricsWithBasicAttributes} from "src/katalMetrics/metricsHelperMethods"
import { getDisplayName } from '../utils/displayNameUtils';
import { getPreference, createPreference, updatePreference, listPreference } from 'src/utilities/AppSyncPlusAPIs';
import { v4 as uuidv4 } from 'uuid';
import { mergeColumnStateAndDef } from 'src/utilities/HistoryUtils';

const errorColumnDefinitions = [
        {
            id: "starttime",
            header: "starttime",
            cell: e => e.starttime,
            isRowHeader: true
        },
        {
            id: "line_number",
            header: "line_number",
            cell: e => e.line_number
        },
        { id: "position", header: "position", cell: e => e.position },
        { id: "colname", header: "colname", cell: e => e.colname },
        { id: "type", header: "type", cell: e => e.type },
        { id: "raw_field_value", header: "raw_field_value", cell: e => e.raw_field_value },
        { id: "err_reason", header: "err_reason", cell: e => e.err_reason },
        { id: "filename", header: "filename", cell: e => e.filename }
    ]

const FriscoHistory = (props) => {

    const userAuthenticationDetails = useAuth();
    const gridRef = useRef();
    const history = useHistory();
    const dispatch = useDispatch()
    const userLDAPS = userAuthenticationDetails.USER_LDAP_GROUPS;
    const [isCheckingAccess, setIsCheckingAccess] = useState(true);
    const [isAuthorised, setIsAuthorised] = useState(false);
    const [items, setItems] = useState([]);
    const [showLoadingIcon, setShowLoadingIcon] = useState(true);
    const [processData, setProcessData] = useState({})
    const [transactions, setTransactions] = useState([])
    const [loadErrorData, setLoadErrorData] = useState([])
    const [hasColumnChanges, setHasColumnChanges] = useState(false)
    const [isInitialLoadComplete, setIsInitialLoadComplete] = useState(false)
    const [isAdminUser, setIsAdminUser] = useState(false)
    const [fullPreferenceObject, setFullPreferenceObject] = useState(null)
    const [isSavingColumnPreferences, setIsSavingColumnPreferences] = useState(false)
    const [columnPreferenceError, setColumnPreferenceError] = useState("")
    const [columnPreferenceSuccess, setColumnPreferenceSuccess] = useState("")
    const [isResetting, setIsResetting] = useState(false)
    const [hadChangesBeforeReset, setHadChangesBeforeReset] = useState(false)
    const [isSystemUpdate, setIsSystemUpdate] = useState(false)
    const currentStage = useSelector((globalState) => globalState.auth.currentStage)
    const userId = useSelector((globalState) => globalState.auth.userId);
    const [renameModalObj, setRenameModalObj] = useState(null)
    
    // const isCurrentAppAuthorised = useSelector((globalState) => globalState.auth.isCurrentAppAuthorized)
    const currentAppId = useSelector(
        (globalState) => globalState.auth.currentAppId
      );
    let { id: paramId } = useParams();
    let { pid: paramPid } = useParams();
    
    const id = props.id || paramId;
    const pid = props.pid || paramPid;
    const [backUrl, setBackUrl] = useState(null)

    const ln = useLocation()
    useVisibleTimeTracker([{
        metricName : 'actionPerformedBy',
        metricValue : userId,
        metricType : METRIC_TYPE.STRING,
        isMonitor : true
    },
    {
        metricName : 'pagePath',
        metricValue : `${ln.pathname}`,
        metricType : METRIC_TYPE.STRING,
        isMonitor : true
    }
    ], "timeSpent", ACTION_METHODS.TIME_SPENT_ON_PAGE, SITE_SERVICES.FRISCO);

    useEffect(() => {
        configureFriscoS3()
        loadData()
        setBackUrl(getParam('back'))
        if(id){
            dispatch(setCurrentAppId(id))
        }
        return () => {
            configureGenericS3()
        };
    }, []);

    useEffect(() => {
        if (pid) {
            loadColumnPreferences(
                (savedState) => {
                    setIsSystemUpdate(true);
                    
                    if (savedState && savedState.columnState && savedState.columnState.length > 0) {
                        // Apply saved column order and visibility to columnDefs
                        const reorderedCols = savedState.columnState
                            .filter(col => !col.hide)
                            .map(savedCol => {
                                const baseColDef = defaultColumnDefs.find(defCol => defCol.field === savedCol.colId);
                                const savedColDef = savedState.columnDefinition?.find(def => def.field === savedCol.colId);
                                return mergeColumnStateAndDef(baseColDef, savedColDef)
                            })
                            .filter(Boolean);
                        setColumnDefs(reorderedCols);
                    } else {
                        setColumnDefs(getColumnDefsWithTANCVisibility(defaultColumnDefs));
                    }
                    
                    setTimeout(() => {
                        setIsSystemUpdate(false);
                    }, 100);
                },
                (error) => {
                    console.error('Error loading column preferences:', error);
                    setIsSystemUpdate(true);
                    setColumnDefs(getColumnDefsWithTANCVisibility(defaultColumnDefs));
                    setTimeout(() => {
                        setIsSystemUpdate(false);
                    }, 100);
                }
            );
        }
    }, [pid, processData]);

    const getS3FolderPath = (item) => {
        let status = item.processingStatus.toLowerCase()
        switch (status) {
            case 'completed': return 'completed';
            case 'pending':
            case 'processing': return 'pending';
            default: return status
        }
    }

    const processIcon = props => (
        props.data.status === 'Completed' ?
            <Box>
                <Icon name='status-positive' variant='success' ></Icon>
            </Box>

            : <Box>
                <Icon name='status-in-progress' variant='normal' ></Icon>
            </Box>


    )

    const downloadSupportingDocuments = async (item) => {
        if(item == null || item?.supportingDocuments == null){
            return
        }
        const files = item.supportingDocuments;
        files.forEach(async (file) => {
            let filefn = file.replace('frisco/', '');
            if (filefn?.includes('stage/')) {
                filefn = filefn.replace('stage/', 'source/');
            }
            const result = await Storage.get(decodeURIComponent(cleanS3PathForDownload(filefn)).replaceAll('ABCPLUSTEMP', '+'), 
                { level: 'public', customPrefix: { public: 'frisco/' }, expires: 60 });
            window.open(result);
        });
    }
    function cleanS3PathForDownload(path){
/*
        If s3 object name has a space. S3 replaces it with a +. 
        However, if it has a space and +, s3 resolves the space as + hence there is a resolution conflict between + and ' '. 
        S3 also responds with by replacing + as %2B when the file is uploaded via storage. 
        So, we have to replace the + with space and then %2B as + which then creates a correct downloadable key format.
        */
        if(path.includes('+') && path.includes('%2B')){
            path=path.replaceAll('%2B', 'ABCPLUSTEMP')
            path=path.replaceAll('+', ' ')
        }else if(path.includes(' ') && path.includes('+')){
            // thjis is because the UI updated the raw file path wrongly. Storage response key is diff conpared to the  key that s3 throws in trigger event
            // fn=fn.replaceAll('+', '')
        }
        return path
    }

    const downloadRawFile= async (item) => {
        if(item == null || item?.rawFilePath == null || item?.rawFilePath == ''){
            return
        }
        configureFriscoS3()
        let fn = `${item.rawFilePath}`
        fn = fn.replace('frisco/','')
        let prefix = 'frisco/'

        /*
        If s3 object name has a space. S3 replaces it with a +. 
        However, if it has a space and +, s3 resolves the space as + hence there is a resolution conflict between + and ' '. 
        S3 also responds with by replacing + as %2B when the file is uploaded via storage. 
        So, we have to replace the + with space and then %2B as + which then creates a correct downloadable key format.
        */
        if(fn.includes('+') && fn.includes('%2B')){
            fn=fn.replaceAll('%2B', 'ABCPLUSTEMP')
            fn=fn.replaceAll('+', ' ')
        }
        const result = await Storage.get(decodeURIComponent(fn).replaceAll('ABCPLUSTEMP','+'), { level: 'public', customPrefix:{public:prefix}, expires: 60 });
        window.open(result);
    }
    const downloadFile = async (item) => {
        if(item == null || item?.filePath == null || item?.filePath == ''){
            return
        }
        configureFriscoS3()
        let fn = `${item.filePath}`
        fn = fn.replace('frisco/','')
        let prefix = 'frisco/'
        const result = await Storage.get(fn, { level: 'public', customPrefix:{public:prefix}, expires: 60 });
        window.open(result);
    }

    const isParentFolderIdExist = (value) => {
        return value?.uploadParentFolderId?.trim() !== ''
    }

    const getWorkDocsParentFolderId = (workdocsPaths) => {
        for (let key in workdocsPaths) {
            if (!key) {
                continue
            }
            if (Array.isArray(workdocsPaths[key])) {
                for (let i in workdocsPaths[key]) {
                    if (isParentFolderIdExist(workdocsPaths[key][i])) {
                        return workdocsPaths[key][i]?.uploadParentFolderId
                    }
                }
            } else if (isParentFolderIdExist(workdocsPaths[key])) {
                return workdocsPaths[key]?.uploadParentFolderId
            }
        }
    }

    const downloadIcon = props => {
        const workdocsLink = getWorkDocsParentFolderId(JSON.parse(props.data.workdocsPaths) || {}) || null
        let filePathArr = [props.data.filePath]
        if(props.data?.supportingDocuments){
            filePathArr = filePathArr.concat(props.data.supportingDocuments);
        }
        if(props.data.rawFilePath){
            filePathArr.push(props.data.rawFilePath);
        }
        return(
        <SpaceBetween size='m' direction='horizontal'>
            {workdocsLink &&
                    <Button iconName="external" variant="inline-icon" ariaLabel="Open in Workdocs" className="workdocs-button" onClick={()=>{ window.open(`${workdocsBaseUrl}${workdocsLink}`, '_blank')}}>
                      Open in Workdocs
                    </Button>
            }
            {
            filePathArr?.length > 0 &&  
            <ExpandableSection headerText={<Box>Download</Box>}
                    headerActions={
                        <Button
            variant='inline-link'
            onClick={() => {
                downloadFile(props.data)
                downloadSupportingDocuments(props.data)
                downloadRawFile(props.data)
            }
            }> All </Button>
                    }
                >
                    <FriscoTransactionFileListViewer transactionDetails={props.data} liteView={true} allFileList={filePathArr}></FriscoTransactionFileListViewer>
                </ExpandableSection>
                
        }
            {/* {
                props.data.workdocsUploadStatus == "WORKDOCS_UPLOAD_SUCCESS" ?
                    <Button
                        variant='inline-link'
                        onClick={() => {
                            console.log(JSON.parse(props.data.workdocsPaths)['file'])
                        }
                        }> [Workdocs] </Button>
                    : <></>
            } */}
        </SpaceBetween>
        )
    }

    const epochToTimestamp = props => (
        <Box>{  convertEpochToPST(Number(props.data.uploadedTimestamp))  }</Box>
    )
    const epochToTimestampLastUpdatedTime = props => (
        <Box>{ convertEpochToPST(Number(props.data.lastUpdatedTimestamp))   }</Box>
    )
    const epochToTimestampJobModificationTime = props => (
        <Box>{ convertEpochToPST(Number(props.data.jobStatusModificationTimestamp))   }</Box>
    )

    const epochToTimestampApprovalRequestedTime = props => (
        props.data?.approvalRequestedTime?
        <Box>{ convertEpochToPST(Number(props.data?.approvalRequestedTime))   }</Box>:
        <Box></Box>
    )

    const epochToTimestampApprovalModificationTime = props => (
        props.data?.approvalModificationTime?
        <Box>{ convertEpochToPST(Number(props.data?.approvalModificationTime))   }</Box>:
        <Box></Box>
    )
    

    const processImg = (props) => (
        <Box float="left">
          <img
            alt=""
            className="rounded-circle"
            src={
              "https://internal-cdn.amazon.com/badgephotos.amazon.com/?uid=" +
              props.data.uploadedBy
            }
            width={20}
            height={20}
          />
          &nbsp;
          <a
            target="_blank"
            rel="noopener noreferrer"
            href={"https://phonetool.amazon.com/users/" + props.data.uploadedBy}
          >
            {props.data.uploadedBy}
          </a>
        </Box>
      );

    const  processImgApprovedBy = (props) => (
        props.data.approvedBy ? <Box float="left">
          <img
            alt=""
            className="rounded-circle"
            src={
              "https://internal-cdn.amazon.com/badgephotos.amazon.com/?uid=" +
              props.data.approvedBy
            }
            width={20}
            height={20}
          />
          &nbsp;
          <a
            target="_blank"
            rel="noopener noreferrer"
            href={"https://phonetool.amazon.com/users/" + props.data.approvedBy}
          >
            {props.data.approvedBy}
          </a>
        </Box> : <Box></Box>
      );


    const renderFileIDField = (props) =>{
        let parsedErrors = props.data.stlErrors ? Array.from(JSON.parse(props.data.stlErrors)) : []
        parsedErrors = parsedErrors.map((i)=>{return{...i, key: i.starttime}})

        return(
            <>
                {/* Code for error logic and displaying modal */}
                {parsedErrors && parsedErrors.length > 0 ? (
                    <Button iconName="status-info" variant="inline-icon" ariaLabel="Show Errors" className="error-button" onClick={() => { setLoadErrorData(parsedErrors) }}>
                        View Errors
                    </Button>
                ) : (
                    <span style={{ marginRight: "22px" }}></span>
                )}
                <CopyToClipboard
                    copyButtonAriaLabel="Copy File id"
                    copyErrorText="Failed to copy"
                    copySuccessText="File id copied"
                    textToCopy={props.data.fileId || '-'}
                    variant="icon"
                />
                <Link href={`/frisco/file/${props.data.fileId}`}>{props.data.fileId} </Link>
            </>
        )
    }

    const renderFileName = (props) =>{
        return(
            <>
                {props.data.uploadedFileName}
            </>
        )
    }
    const approvalStatusButton = (props) => {
        if (props?.data.approvalStatus == 'pending') {
            return  <Link external href={`/ApprovalsHome/Workflow/${props.data.approvalId}`}> <span className='orange_badge' >{props.data.approvalStatus}</span> </Link>
          } else if (props.data.approvalStatus == 'completed') {
            return <Link external href={`/ApprovalsHome/Workflow/${props.data.approvalId}`}> <span className='green_badge' >{props.data.approvalStatus}</span> </Link>
          } else if (props.data.approvalStatus == 'rejected') {
            return <Link external href={`/ApprovalsHome/Workflow/${props.data.approvalId}`}> <span className='red_badge' >{props.data.approvalStatus}</span> </Link>
          } else if (props.data.approvalStatus == 'cancelled') {
            return <Link external href={`/ApprovalsHome/Workflow/${props.data.approvalId}`}> <span className='grey_badge' >{props.data.approvalStatus}</span> </Link>
          } else if (props.data.approvalStatus == 'NO APPROVAL') {
            return  <span className='blue_badge' >{props.data.approvalStatus}</span> 
          } else {
            if(props.data.approvalId){
                return <Link external href={`/ApprovalsHome/Workflow/${props.data.approvalId}`}> <span className='blue_badge' >{props.data.approvalStatus}</span> </Link>
            }else{
                return <span className='blue_badge' >{props.data.approvalStatus}</span>
            }
          }
    }


    const defaultColumnDefs = [
         { field: 'uploadedFileName', width: '300px',  headerName: 'Uploaded File Name', cellRenderer:renderFileName, sortable: true, resizable: true, hide: processData[PROCESS_KEYS.environment] !== "Transfer_FAST_RedShift"  },
         { field: 'status', width: '200px', headerName: 'Status', sortable: true, resizable: true },
         { field: 'wbType', width: '150px', headerName: 'Version', sortable: true, resizable: true, hide: currentAppId != appSettings[currentStage]['appId'] } ,
         { field: 'Input(s)', width: '350px', autoHeight: true, cellRenderer: downloadIcon },
         { field: 'uploadedBy', width: '150px', headerName: 'Uploaded by', cellRenderer:processImg, sortable: true, resizable: true },
         { field: 'approvalStatus', width: '200px', headerName: 'Approval status', sortable: true, cellRenderer:approvalStatusButton , resizable: true , hide: currentAppId == appSettings[currentStage]['appId']},
         { field: 'approvedBy', width: '150px', headerName: 'Approved by', cellRenderer:processImgApprovedBy, sortable: true, resizable: true , hide: currentAppId == appSettings[currentStage]['appId']},
         { field: 'lastUpdatedTimestamp', width: '250px', headerName: 'Last updated', sortable: true,  cellRenderer: epochToTimestampLastUpdatedTime, resizable: true },
         { field: 'uploadedTimestamp', width: '250px',  headerName: 'Uploaded time', sortable: true, cellRenderer: epochToTimestamp, resizable: true },
         { field: 'approvalRequestedTime', width: '250px', headerName: 'Approval requested', cellRenderer: epochToTimestampApprovalRequestedTime,sortable: true, resizable: true , hide: currentAppId == appSettings[currentStage]['appId']},
         { field: 'approvalModificationTime', width: '250px', headerName: 'Approval modification time',cellRenderer: epochToTimestampApprovalModificationTime, sortable: true, resizable: true , hide: currentAppId == appSettings[currentStage]['appId']},
         { field: 'jobStartTime', width: '250px', headerName: 'Job start time', sortable: true, resizable: true , hide: currentAppId == appSettings[currentStage]['appId']},
         { field: 'fileId', width: '400px',  headerName: 'file id', cellRenderer: renderFileIDField, sortable: true, resizable: true }
         // { field: 'filePath', width: '300px', headerName: 'Check for errors ?', cellRenderer: stlErrorsContent, sortable: true, resizable: true}
     ];

    const getColumnDefsWithTANCVisibility = (columnDefs) => {
        return columnDefs.map(col => {
            if (col.field === 'uploadedFileName') {
                return {
                    ...col,
                    hide: processData[PROCESS_KEYS.environment] !== "Transfer_FAST_RedShift"
                };
            }
            return col;
        });
    };
    const [columnDefs, setColumnDefs] = useState(defaultColumnDefs)

    const defaultColDef = {
        // set filtering on for all columns
        filter: true,
        filterParams: {
            buttons: ["reset"],
            debounceMs: 200,
        },
    };

    const getMainMenuItems = useCallback((params) => {
        return [
            ...params.defaultItems,
            "separator",
            {
                name: "Rename column name",
                action: () => {
                    // Save current column state before opening modal to prevent position reset
                    setRenameModalObj({ original: params.column, new: params.column.colDef.headerName || params.column.colDef.field, preState: { state: gridRef.current.api.getColumnState() } })
                }
            },
        ];
    }, []);


    const checkAdminStatus = async () => {
        let isAdmin = await checkIfPortalAdmin(userId, currentStage) || await checkIfSupportAdmin(userId, currentStage);
        setIsAdminUser(isAdmin);
    };

    const handleAccess = async (data) => {
        let resp = false
        if (data[PROCESS_KEYS.created_by] == userId) {
            resp = true
        } else {
            resp = await checkIfPortalAdmin(userId, currentStage)
            if(!resp){
                resp = await checkIfSupportAdmin(userId, currentStage)
            }
            // temporary if condition for internal testing - the portal/support admin conditions are ignored for CRA app to simulate normal acc users permissions
            if (id == appSettings[currentStage].appId) {
                resp = false
            }

            if(!resp && id == appSettings[currentStage]['appId']){
                resp = await isCorpAdmin(userId,id,currentStage)
                resp = resp['admin']
            }
            if (!resp) {
                resp = await isUploaderAllowed(data, userId, currentStage)
            }
            if (!resp) {
                resp = await isApprover(data, userId, currentStage)
            }
        }
        
        setIsAuthorised(resp)
        setIsCheckingAccess(false)
    }

    const loadColumnPreferences = (onSuccess, onError) => {
        if (!pid) {
            onSuccess(null);
            return;
        }
        
        listPreference(
            pid,                        
            'FRISCO',                  
            'HISTORY_COLUMN_PREF',      
            function onSuccessResponse(response) {
                const preferences = response?.data?.listPreference?.items || [];
                
                const validPreferences = preferences.filter(pref => {
                    if (pref.information) {
                        const information = typeof pref.information === 'string'
                            ? JSON.parse(pref.information)
                            : pref.information;
                        return information;
                    }
                    return false;
                });

                if (validPreferences.length > 0) {
                    const firstPreference = validPreferences[0];
                    setFullPreferenceObject(firstPreference);
                    const information = JSON.parse(firstPreference.information);
                    onSuccess(information);
                } else {
                    setFullPreferenceObject(null);
                    onSuccess(null);
                }
            },
            function onFailureResponse(error) {
                setFullPreferenceObject(null);
                onError(error);
            }
        );
    };

    const saveColumnPreferences = (state, columnDefinition) => {
        if (!pid || !state) return;

        setColumnPreferenceError("");
        setIsSavingColumnPreferences(true);

        const label = `Column preferences for Frisco ${pid}`;
        const information = {
            columnState: state,
            columnDefinition: columnDefinition
        };
        
        if (fullPreferenceObject?.preferenceId) {
            updatePreference(
                fullPreferenceObject.preferenceId,
                label,
                userId,
                information,
                () => {
                    setHasColumnChanges(false);
                    setIsSavingColumnPreferences(false);
                },
                (error) => {
                    console.error('Error updating column preferences:', error);
                    const errorMessage = error?.errors?.[0]?.message || error?.message || "Failed to save column preferences";
                    setColumnPreferenceError(errorMessage);
                    setIsSavingColumnPreferences(false);
                }
            );
        } else {
            const newPreferenceId = uuidv4();
            createPreference(
                newPreferenceId,
                'HISTORY_COLUMN_PREF',
                label,
                pid,                 
                'FRISCO',           
                userId,
                information,
                null,              
                (response) => {
                    const newPreference = {
                        preferenceId: newPreferenceId,
                        label: label,
                        associationId: pid,
                        associationIdType: 'FRISCO',
                        preferenceType: 'HISTORY_COLUMN_PREF',
                        createdBy: userId,
                        lastUpdatedBy: userId,
                        lastUpdatedTimestamp: Date.now().toString(),
                        information: information
                    };
                    setFullPreferenceObject(newPreference);
                    setHasColumnChanges(false);
                    setIsSavingColumnPreferences(false);
                },
                (error) => {
                    console.error('Error creating column preferences:', error);
                    const errorMessage = error?.errors?.[0]?.message || error?.message || "Failed to save column preferences";
                    setColumnPreferenceError(errorMessage);
                    setIsSavingColumnPreferences(false);
                }
            );
        }
    };

    const handleColumnEvent = () => {
        if (isInitialLoadComplete && !isSystemUpdate) {
            setHasColumnChanges(true);
        }
    };

    const handleColumnVisibilityEvent = () => {
        if (isInitialLoadComplete && !isSystemUpdate) {
            setHasColumnChanges(true);
        }
    };

    const onGridReady = (params) => {
        setIsInitialLoadComplete(true);
    };

    const handleSaveColumnLayout = () => {
        if (gridRef.current?.api) {
            const currentState = gridRef.current.api.getColumnState();
            const updatedColumnDefs = currentState
                .filter(col => !col.hide)
                .map(colState => {
                    return mergeColumnStateAndDef(defaultColumnDefs.find(defCol => defCol.field === colState.colId), gridRef.current.api.getColumnDefs()?.find(def => def.field === colState.colId) );
                })
                .filter(Boolean);
            
            setColumnDefs(updatedColumnDefs);
            saveColumnPreferences(currentState, gridRef.current.api.getColumnDefs());
        }
    };

    const resetColumnlayout = () => {
        if (gridRef.current?.api) {
            setColumnPreferenceError("");
            setIsResetting(true);
            setHadChangesBeforeReset(hasColumnChanges);
            
            setTimeout(() => {
                const defaultState = defaultColumnDefs.map((col, index) => ({
                    colId: col.field,
                    hide: col.field === 'uploadedFileName' ? 
                        processData[PROCESS_KEYS.environment] !== "Transfer_FAST_RedShift" : 
                        (col.hide || false),
                    pinned: null,
                    sort: null,
                    sortIndex: null,
                    aggFunc: null,
                    width: col.width ? parseInt(col.width) : undefined,
                    flex: null,
                    rowGroupIndex: null,
                    pivotIndex: null
                }));
                
                gridRef.current.api.applyColumnState({
                    state: defaultState,
                    applyOrder: true
                });
                
                const resetColumnDefs = getColumnDefsWithTANCVisibility(defaultColumnDefs);
                setColumnDefs(resetColumnDefs);
                
                setHasColumnChanges(hadChangesBeforeReset);
                setIsResetting(false);
            }, 300); 
        }
    };

    // Example flow of how the below function would work
    // Call loadFriscoPagedData("sometoken1", [1])
    const loadFriscoPagedData = async (nextToken, resultJSON) => {
        // Return a new promise that will RESOLVE to the final payload after all the entries have been fetched recursively
        return new Promise((resolve, reject) => {
            // Use the "sometoken1" along with [1]
            queryFRISCOTransactionsByAppIdProcessIdIndex(id, pid, 1000, nextToken, 
                function onSuccess(response) {
                    // results from some token 1 and next token if exists

                    // assume result is [2]
                    let localResult = response.data.queryFRISCOTransactionsByAppIdProcessIdIndex.items;

                    //assume there is token2
                    let newNextToken = response.data.queryFRISCOTransactionsByAppIdProcessIdIndex.nextToken;
                    
                    if(newNextToken) {
                        // IF there is a new Next token it means there are more results to fetch, 
                        // So append the current results to the existing result set and pass it as base 
                        // into the recursive function

                        // if its in here it means its going to use token 2  along with resultJSON:[1] and localResult:[2] and 
                        // this call will be loadFriscoPagedData("sometoken2", [1,2])
                        loadFriscoPagedData(newNextToken, resultJSON.concat(localResult))
                            .then(moreResults => resolve(moreResults))
                            .catch(err => reject(err));
                    } else {
                        // At this point in the code there are no more entries to fetch so resolve one last time by 
                        // appending the last data set to pre existing dataset entries
                        // THIS is what will be returned finally to the root function call in loadData 

                        // at this point there is no more token and we hava all results 
                        // so resolve one final time by concatenating [1,2...n]
                        resolve(resultJSON.concat(localResult));
                    }
                }, 
                function onFailure(fail) {
                    setShowLoadingIcon(false);
                    resolve(resultJSON);
                }
            );
        });
    }

    const loadData = async () => {
        const pageLoadTime = createKatalTimerStopWatch("timeTaken")
        try {
        await Promise.all([
        new Promise((resolve, reject) => {
            setShowLoadingIcon(true)
        getProcessById(pid, async function onSuccess(response) {
            setProcessData(response.data.getProcessByIDV2RDS)
            await handleAccess(response.data.getProcessByIDV2RDS)
            await checkAdminStatus()
            stopAndCaptureTimeMetricsWithBasicAttributes(pageLoadTime, userId, `${ln.pathname}${location.search}`,ACTION_METHODS.PAGE_LOAD_TIME , SITE_SERVICES.FRISCO)
        }, function onFailure(response) {
            reject();
        })
        }),

        new Promise((resolve, reject) => {
            queryFRISCOTransactionsByAppIdProcessIdIndex(id, pid, 1000, null, async function onSuccess(response) {
            setTransactions(response.data.queryFRISCOTransactionsByAppIdProcessIdIndex)
            let qResultJSON = response.data.queryFRISCOTransactionsByAppIdProcessIdIndex.items

            let nextToken =  response.data.queryFRISCOTransactionsByAppIdProcessIdIndex.nextToken
            if(nextToken){
                qResultJSON = await loadFriscoPagedData(nextToken, qResultJSON)
            }

            qResultJSON.sort(function (a, b) {
                var dateA = new Date(Number(a.lastUpdatedTimestamp)), dateB = new Date(Number(b.lastUpdatedTimestamp));
                return dateB - dateA;
            });
            setItems(qResultJSON)
            setShowLoadingIcon(false)
            resolve();
        }, function onFailure(response) {
            setShowLoadingIcon(false)
            reject();
        })
        })
        ]);



    } finally {
        if(!pageLoadTime.isStopped) {
        stopAndCaptureTimeMetricsWithBasicAttributes(pageLoadTime, userId, `${ln.pathname}${location.search}`,ACTION_METHODS.PAGE_LOAD_TIME , SITE_SERVICES.FRISCO)
    }
    }
    }


    const onFollowHandler = (ev) => {

        ev.preventDefault();
        if (ev.detail.href) {
            history.push(ev.detail.href.substring(1));
        }
    }

    const getParam= (key) => {
        const search = props?.location?.search;
        const params = new URLSearchParams(search);
        const value = params.get(key);
        return value;
      }

    const getProcessDisplayName = () => {
        const aliasParam = getParam('alias');
        return getDisplayName(aliasParam, processData[PROCESS_KEYS.process_name], processData[PROCESS_KEYS.label]);
    }


    const saveRenameColumn = (renameObj) => {
        if (!renameObj || !renameObj.new || !renameObj.original) {
            return;
        }
        
        const newHeaderName = renameObj.new.trim();
        if (newHeaderName === '') {
            return;
        }

        gridRef.current.api.applyColumnState({
                    state: renameModalObj.preState.state,
                    applyOrder: true
                });

        // Update the column definition with new header name
        const updatedColumnDefs = gridRef?.current.api.getColumnDefs().map(colDef => {
            if (colDef.field === renameObj.original.colDef.field) {
                return {
                    ...colDef,
                    headerName: newHeaderName
                };
            }
            return colDef;
        });

        // Update the column definitions state - React will automatically re-render the grid
        setColumnDefs(updatedColumnDefs);

        // Mark that changes have been made
        setHasColumnChanges(true);
        
        // Close the rename modal
        setRenameModalObj(null);
    };


    const content = (
        <div>

            {
                isAuthorised?
                <Box>
                    <SpaceBetween size='l'>
                    <Container
                        header={
                            <Header
                                variant='h2'
                                actions={
                                    <SpaceBetween direction="horizontal" size="xs">
                                        <Button variant='normal' onClick={() => { 
                                            if (props.selectedSidebarContent) {
                                                const uploadTab = props.selectedSidebarContent.find(
                                                    tab => tab.label.toLowerCase() === 'upload'
                                                );
                                                
                                                if (uploadTab && uploadTab.action) {
                                                    uploadTab.action();
                                                } else {
                                                    history.push(`/App/${id}/process/${pid}/upload?back=${backUrl}`);
                                                }
                                            } else {
                                                history.push(`/App/${id}/process/${pid}/upload?back=${backUrl}`);
                                            }
                                        }}>
                                            Upload file
                                        </Button>
                                    </SpaceBetween>
                                }
                                description=""
                            >Upload file for process - {getProcessDisplayName()}


                            </Header>
                        }
                    >
                            {
                                processData?.hasOwnProperty(PROCESS_KEYS.environment) && processData[PROCESS_KEYS.environment] === "Transfer_FAST_RedShift" &&  processData?.hasOwnProperty(PROCESS_KEYS.team) && processData?.hasOwnProperty(PROCESS_KEYS.business)
                                    && processData?.hasOwnProperty(PROCESS_KEYS.dataset_name) &&  currentAppId != appSettings[currentStage]['appId'] ?
                                    <SpaceBetween size='s' direction='horizontal'>
                                        <Box variant="h4"> Load table : </Box>
                                        {
                                            processData[PROCESS_KEYS.redshift_table_name] ? 
                                            <Box>{processData[PROCESS_KEYS.redshift_table_name]}</Box>:
                                            <Box variant="p"> {processData[PROCESS_KEYS.team]}_{processData[PROCESS_KEYS.business]}_{processData[PROCESS_KEYS.dataset_name]}</Box>
                                        }
                                    </SpaceBetween> : <></>
                            }
                    </Container>

                        <Container
                            header={
                                <Header
                                    variant='h2'
                                    actions={
                                        <SpaceBetween direction="horizontal" size="xs">
                            {hasColumnChanges && isAdminUser && (
                                <Button 
                                    variant='primary' 
                                    onClick={handleSaveColumnLayout}
                                    loading={isSavingColumnPreferences}
                                    disabled={isSavingColumnPreferences || isResetting}
                                >
                                    Save view
                                </Button>
                            )}
                                             <Button 
                                                variant='link' 
                                                onClick={resetColumnlayout}
                                                loading={isResetting}
                                                disabled={isSavingColumnPreferences || isResetting}
                                            >
                                                Reset view
                                            </Button>
                                            <Button variant='normal' iconName='refresh' onClick={loadData}></Button>
                                        </SpaceBetween>
                                    }
                                    description="The following table shows all the files uploaded."
                                >File Uploads
                                    {showLoadingIcon ?
                                        <Spinner size='normal'></Spinner> : <div></div>
                                    }

                                </Header>
                            }
                            fitHeight
                        >
                            {columnPreferenceError && (
                                <Box margin={{ bottom: "s" }}>
                                    <StatusIndicator type="error">{columnPreferenceError}</StatusIndicator>
                                </Box>
                            )}
                            <div
                                className="ag-theme-alpine"
                                style={{ height: 600, width: "100%" }}
                            >
                                <AgGridReact
                                    ref={gridRef}
                                    rowData={items}
                                    defaultColDef={defaultColDef}
                                    columnDefs={columnDefs}
                                    rowSelection='single'
                                    animateRows={true}
                                    rowHeight={40}
                                    enableCellTextSelection={true}
                                    onColumnMoved={handleColumnEvent}
                                    onColumnVisible={handleColumnVisibilityEvent}
                                    onGridReady={onGridReady}
                                    getMainMenuItems={getMainMenuItems}
                                    pagination={true}
                                    paginationPageSize={20}
                                    paginationPageSizeSelector={[10, 20, 50, 100]}
                                    suppressPaginationPanel={false}
                                >
                                </AgGridReact>
                            </div>
                        </Container>
                    </SpaceBetween>
                    <Modal
                        onDismiss={() => {
                            setLoadErrorData([])
                        }}
                        visible={loadErrorData.length > 0}
                        size="max"
                        footer={
                            <Box float="right">
                                <SpaceBetween direction="horizontal" size="xs">
                                    <Button variant="primary" onClick={() => {
                                        setLoadErrorData([])
                                    }}>
                                        Close
                                    </Button>
                                </SpaceBetween>
                            </Box>
                        }
                    >
                        <FriscoJobErrors
                            header={'STL Load Errors Table Data For The Uploaded File'}
                            errorData={loadErrorData}
                            columnDefinitions={errorColumnDefinitions}
                        />
                    </Modal>
                                <Modal
                                    onDismiss={() => {
                                        setRenameModalObj(null)
                                    }}
                                    visible={renameModalObj}
                                    footer={
                                        <Box float="right">
                                            <SpaceBetween direction="horizontal" size="xs">
                                                <Button variant="primary" onClick={() => {
                                                    saveRenameColumn(renameModalObj)
                                                }}>
                                                    Save
                                                </Button>
                                                <Button  onClick={() => {
                                                    setRenameModalObj(null)
                                                }}>
                                                    Close
                                                </Button>
                                            </SpaceBetween>
                                        </Box>
                                    }
                                    header={`Rename column ${renameModalObj?.original.colDef.headerName || renameModalObj?.original.colDef.field}`}
                                    >
                    
                                    <Input
                          onChange={({ detail }) => setRenameModalObj({...renameModalObj, new: detail.value})}
                          value={renameModalObj?.new}
                        />
                    
                                </Modal>
                    </Box> : isCheckingAccess ? <div>
                        <WaitForPageAccess></WaitForPageAccess>
                    </div> :
                        <Alert
                            statusIconAriaLabel="Error"
                            type="error"
                            header="Access denied"
                        >
                            {
                                currentAppId == appSettings[currentStage]['appId'] ?
                                "You don't have permission to view the history. You are not part of the Uploader/Approver group for this deliverable  If you believe you should have access please contact the SEC team to request membership in the appropriate group":
                                "No access to view"

                            }
                        </Alert>
            }
        </div>
    )


    return (
        <AppLayout
            content={content}
            navigation={ <SideNav activeHref={`/App/${id}/process/${pid}/history`} id={id} pid={pid} process={processData} back={backUrl}/>}
            headerSelector="#TopBar"
            navigationHide={props.disableAppLayout}
            disableBodyScroll={true}
            toolsHide={true}
            headerVariant="high-contrast"
        ></AppLayout>
    )
}



export default FriscoHistory
